<template>
  <div id="left-ruler-component">
    <canvas id="left-ruler" ref="leftRulerRef"></canvas>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref, onMounted, watch, inject } from "vue";
import { fabric } from "fabric";
import { makeRulerCanvas, drawLeftRuler } from "./Rulers";
import { canvas } from "@/canvas-api/Canvas";
import { zoomValue, isZooming } from "@/canvas-api/Zoom";
import { LineProperties } from "@/types";

export default defineComponent({
  name: "Rulers",
  setup() {
    const leftRulerRef = ref<HTMLCanvasElement>();
    const leftRulerCanvas = ref<fabric.Canvas>(new fabric.Canvas(null));
    const leftRulerWidth = 40;
    const leftRulerHeight = ref(canvas.value.getHeight());

    const leftRulerGroup = ref(new fabric.Group(undefined));

    const baseLineProps: LineProperties = {
      type: "line",
      id: "baseLine",
      name: "baseLine",
      originX: "center",
      originY: "center",
      stroke: "black",
      strokeWidth: 1,
      selectable: false,
      evented: false,
      strokeDashArray: undefined,
    };

    onMounted(() => {
      if (leftRulerRef.value) {
        leftRulerCanvas.value = makeRulerCanvas(
          leftRulerCanvas.value,
          leftRulerWidth,
          leftRulerHeight.value,
          "left-ruler-container",
          leftRulerRef.value
        );

        const rulerTop = leftRulerCanvas.value.getCenter().top;
        
        leftRulerGroup.value = drawLeftRuler(
          rulerTop,
          leftRulerWidth,
          leftRulerHeight.value,
          baseLineProps,
          canvas.value.getZoom()
        );

        leftRulerCanvas.value.add(leftRulerGroup.value).renderAll();
      }
    });

    const isResizing = inject<Ref<boolean>>("isResizing", ref(false));
    //Watch for zoomVal and isZooming from BottomToolBar.vue
    //Redraw ruler when user is done zooming canvas to avoid excessive rerenders
    watch([zoomValue, isZooming, isResizing], (newVals: (number | boolean)[]) => {
      const isZooming = newVals[1];
      const isResizing = newVals[2];

      if (!isZooming && !isResizing) {
        leftRulerHeight.value = canvas.value.getHeight();
        leftRulerCanvas.value.setHeight(leftRulerHeight.value);

        leftRulerCanvas.value.remove(leftRulerGroup.value);

        const rulerTop = leftRulerCanvas.value.getCenter().top;

        leftRulerGroup.value = drawLeftRuler(
          rulerTop,
          leftRulerWidth,
          leftRulerHeight.value,
          baseLineProps,
          canvas.value.getZoom()
        );

        leftRulerCanvas.value.add(leftRulerGroup.value).renderAll();
      }
    });

    return {
      leftRulerRef,
      leftRulerCanvas,
    };
  },
});
</script>

<style scoped>
#left-ruler-component {
  position: absolute;
  z-index: 1;
}
</style>
